import React from 'react'
import { Link } from 'gatsby'
import { createSlug } from '../core/urls'
import { formatOpeningTimeDays, getTodaysDate } from '../core'

const getStoreType = storeType =>
  ({
    Franchise: 'Franchise',
    McColls: 'Morrisons Daily',
    GasStation: 'Petrol Station',
    Morrisons: 'Supermarket',
  }?.[storeType])
const NearbyStores = ({ stores, isMorrisonsDaily }) => {
  return !stores?.length ? null : (
    <section className="w-full my-8 ">
      <div className="mb-2">
        <h3 className="text-xl font-semibold">Nearby Stores</h3>
      </div>
      <section className="flex flex-col w-full gap-4 lg:flex-row ">
        {stores.map(store => {
          const specialOpeningTime = store?.specialOpeningTimes?.find(
            times => times.name === 'supermarket'
          )
          const openingTimes = formatOpeningTimeDays(store?.openingTimes)
          const dateToday = getTodaysDate(specialOpeningTime, openingTimes)
          return (
            <section
              key={store.name}
              itemType="https://schema.org/LocalBusiness"
              className={`relative lg:w-1/3  border border-body-lightest hover:bg-primary-lighter bg-white
`}
            >
              <Link to={`/${store.name}/${createSlug(store.storeName)}`}>
                <section className="flex flex-col h-full p-4 ">
                  <p className="mb-2 text-xs uppercase">
                    {getStoreType(store.storeType?.replace(/\s/g, ''))}
                  </p>
                  <div>
                    <div className="flex items-start justify-between flex-1">
                      <div className="flex pr-3 mb-2">
                        <h3
                          className={`text-lg font-semibold leading-none  text-secondary `}
                        >
                          {store.storeName}
                        </h3>
                      </div>
                    </div>
                    <section
                      itemType="schema.org/PostalAddress"
                      className="my-2 clear-left"
                    >
                      <p className="text-base">
                        {store.address?.addressLine1} <br />
                        {store?.address.postcode}
                      </p>
                    </section>
                  </div>
                  <section
                    itemProp="openingHours"
                    className="mt-auto text-base font-semibold text-primary"
                  >
                    {dateToday ?? null}
                  </section>
                </section>
              </Link>
            </section>
          )
        })}
      </section>
    </section>
  )
}
export default NearbyStores
